import angular from 'angular';

import component from './entity-link.component';

const EntityLink = angular
    .module('control-room.content.components.entity-link', [])
    .component('crEntityLink', component);

export default EntityLink;
